var ppLayoutPanzoom = {};

(function ($) {
    var currentUrl = window.location.href;
    var url = new URL(currentUrl);
    let input = $('input[name="layout"]');

    if(input.length) {
        let firstLayoutId = input.attr('id');
        let firstLayoutNumber = firstLayoutId.substring(firstLayoutId.indexOf('-') + 1);
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)
            searchParams.set("layout", firstLayoutNumber);
            var newParam = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newParam);
        }
    }
    $('.page-template-template-apartment input[name="layout"]').on('change', function() {
        let layout_price = $(this).parents('li').data('layout-price');
        const layoutName = $(this).val();
        const layoutId = $(this).attr('id');
        $('.feature-icons').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-book .full-price').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.page-template-template-apartment .apartment-image').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-images-modal .modal-image[data-slide="1"]').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-images-modal .navigation-image[data-slide="1"]').removeClass('visible').filter(`[data-layout="${layoutName}"]`).addClass('visible');
        $('.apartment-info .has-layout').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-layouts-features .feature-icons.has-layout').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        let layout_number = layoutId.substring(layoutId.indexOf('-') + 1);
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)
            searchParams.set("layout", layout_number);
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
        // Updating price in gform hidden field
        $('.apartment-book .gform_wrapper #input_10_14').val((layout_price+' €'))
        $('.apartment-book .gform_wrapper #input_25_14').val((layout_price+' €'))
        $('.apartment-book .gform_wrapper #input_29_14').val((layout_price+' €'))
        $('.apartment-book .gform_wrapper #input_30_14').val((layout_price+' €'))
        // Updating price in gform hidden field
        $('.apartment-book .gform_wrapper #input_10_28').val($('.apartment-form').data('subject'));
        $('.apartment-book .gform_wrapper #input_25_28').val($('.apartment-form').data('subject'));
        $('.apartment-book .gform_wrapper #input_29_28').val($('.apartment-form').data('subject'));
        $('.apartment-book .gform_wrapper #input_30_28').val($('.apartment-form').data('subject'));
        if(layoutName) {
            $('.apartment-book .gform_wrapper #input_10_28').val($('.apartment-form').data('subject') + ', ' + layoutName);
            $('.apartment-book .gform_wrapper #input_25_28').val($('.apartment-form').data('subject') + ', ' + layoutName);
            $('.apartment-book .gform_wrapper #input_29_28').val($('.apartment-form').data('subject') + ', ' + layoutName);
            $('.apartment-book .gform_wrapper #input_30_28').val($('.apartment-form').data('subject') + ', ' + layoutName);
            // $('.apartment-book .gform_wrapper #input_10_28').val($('.apartment-form').data('subject') + ', ' + layoutName);
        }

        // Changing booking page link layout parameter
        if ($('.booking-link').length) {
            let link = $('.booking-link').attr('href').split('&');
            link.pop();
            link.push(`layout=${layout_number}`);
            link = link.join('&');
            $('.booking-link').attr('href', link);
        }

        // Hiding/showing HD links based on layout selection
        //$('.hd-link-button').hide();
        //$(`.hd-link-button[data-layout="${layout_number}"]`).show();

        $('.js-hd-button').hide();
        $(`.js-hd-button[data-layout="${layout_number}"]`).show();

        // Header v2 prices toggle
        $('.c-header-price__sum-regular').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');
        $('.c-header-price__sum-sale').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');
        $('.c-header-price__sum-strikethrough').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');
        $('.c-layout-selector__extra-price-note').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');
        $('.c-tab-panel').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');
        $('.c-header-price__installment > span').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');

        // Sticky bar
        $('.c-sticky-bar__data__price span.price-value').removeClass('is-active').filter(`[data-layout="${layoutName}"]`).addClass('is-active');

        // Send quote form layout
        $('input[name="apt_layout"]').val(layout_number);
    });
    $('.page-template-template-apartment input[name="layout-mobile"]').on('change', function() {
        const layoutName = $(this).val();
        const layoutId = $(this).attr('id');
        $('.feature-icons').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-book .full-price').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.page-template-template-apartment .apartment-image').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-images-modal .modal-image[data-slide="1"]').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        $('.apartment-images-modal .navigation-image[data-slide="1"]').removeClass('visible').filter(`[data-layout="${layoutName}"]`).addClass('visible');
        $('.apartment-info .has-layout').removeClass('active').filter(`[data-layout="${layoutName}"]`).addClass('active');
        let layout_number = layoutId.substring(layoutId.indexOf('-') + 1);

        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)
            searchParams.set("layout", layout_number);
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
        // Updating price in gform hidden field
        $('.apartment-book .gform_wrapper #input_10_14').val($('.apartment-book .full-price').filter(`[data-layout="${layoutName}"]`).data('layout-price'))
        $('.apartment-book .gform_wrapper #input_25_14').val($('.apartment-book .full-price').filter(`[data-layout="${layoutName}"]`).data('layout-price'))
        $('.apartment-book .gform_wrapper #input_29_14').val($('.apartment-book .full-price').filter(`[data-layout="${layoutName}"]`).data('layout-price'))
        $('.apartment-book .gform_wrapper #input_30_14').val($('.apartment-book .full-price').filter(`[data-layout="${layoutName}"]`).data('layout-price'))
        // Updating price in gform hidden field
        $('.apartment-book .gform_wrapper #input_10_28').val($('.apartment-form').data('subject'));
        $('.apartment-book .gform_wrapper #input_25_28').val($('.apartment-form').data('subject'));
        $('.apartment-book .gform_wrapper #input_29_28').val($('.apartment-form').data('subject'));
        $('.apartment-book .gform_wrapper #input_30_28').val($('.apartment-form').data('subject'));
        if(layoutName) {
            $('.apartment-book .gform_wrapper #input_10_28').val($('.apartment-form').data('subject') + ', '+ layoutName);
            $('.apartment-book .gform_wrapper #input_25_28').val($('.apartment-form').data('subject') + ', '+ layoutName);
            $('.apartment-book .gform_wrapper #input_29_28').val($('.apartment-form').data('subject') + ', '+ layoutName);
            $('.apartment-book .gform_wrapper #input_30_28').val($('.apartment-form').data('subject') + ', '+ layoutName);
        }


        // Changing booking page link layout parameter
        if ($('.booking-link').length) {
            let link = $('.booking-link').attr('href').split('&');
            link.pop();
            link.push(`layout=${layout_number.split('-')[0]}`);
            link = link.join('&');
            $('.booking-link').attr('href', link);
        }

        // Hiding/showing HD links based on layout selection
        $('.hd-link-button').hide();
        $(`.hd-link-button[data-layout="${layout_number.split('-')[0]}"]`).show();

        // Send quote form layout
        $('input[name="apt_layout"]').val(layout_number);
    });

    if ($('#bank-pdf-quote-btn').length) {
        $('#bank-pdf-quote-btn').on('click', function(e) {
            const checkbox = document.getElementById("priceOfferPDF");

            if (checkbox) {
                checkbox.checked = true;
            }
        });
    }

    // Similar apartment table hover image
    if ( liven.table_image_hover ) {
        $('.similar-apartments-table td a').on('mouseenter', function() {
            const image = $(this).closest('tr').data('image');

            if (image.length) {
                $('.similar-apartments .table-hover-image').addClass('active');
                $('.similar-apartments .table-hover-image img').attr('src', image);

                $('.similar-apartments .table-hover-image img').on('load', function() {
                    $(this).addClass('active');
                })
            }
        });
    }

    $('.similar-apartments-table td a').on('mouseleave', function() {
        $('.similar-apartments .table-hover-image').removeClass('active');
        $('.similar-apartments .table-hover-image img').removeClass('active');
    })

    // Apartment images modal
    $('.page-template-template-apartment .apartment-image, .page-template-template-apartment .image-list .image-wrapper').on('click', function() {
        const targetSlide = $(this).data('slide');
        const layout = $(this).data('layout');

        if (layout) {
            $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${targetSlide}"][data-layout="${layout}"]`).addClass('active');
            window.location.hash = 'apartment-images-'+targetSlide+'-layout-'+layout;

        } else {
            window.location.hash = 'apartment-images-'+targetSlide+'-layout-'+layout;
            $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${targetSlide}"]`).addClass('active');
        }

        $('.apartment-images-modal .navigation-image').removeClass('current-slide').filter(`[data-slide="${targetSlide}"]`).addClass('current-slide');
        $('.apartment-images-modal').addClass('active');
        $('body').addClass('overflow-hidden');

    });

    $('.page-template-template-apartment .apartment-image').on('click', function() {
        const targetSlide = $(this).data('slide');
        const layout = $(this).data('layout');
        window.layout1 = layout;
        let displayBoxIndex = targetSlide -1;
        var Navigate = function(diff) {
            displayBoxIndex += diff;
            var oBoxCollection = $(".apartment-images-modal .navigation-image.visible");
            if (displayBoxIndex >= oBoxCollection.length){
                displayBoxIndex = 0;
            }
            if (displayBoxIndex < 0) {
                displayBoxIndex = oBoxCollection.length - 1;
            }
            var cssClass = "current-slide";
            oBoxCollection.removeClass(cssClass).eq(displayBoxIndex).addClass(cssClass);
            if (displayBoxIndex === 0) {
                $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${displayBoxIndex+1}"][data-layout="${layout1}"]`).addClass('active');
            } else {
                $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${displayBoxIndex+1}"]`).addClass('active')
            }
        }

        $("body").keydown(function(e) {
            if (e.keyCode == 37) {//left
                Navigate(-1,targetSlide - 1);
            }
            if(e.keyCode == 39 ) {//right
                Navigate(1,targetSlide - 1);
            }
        })
    })
    $('.page-template-template-apartment .image-list .image-wrapper').on('click', function() {
        const targetSlide = $(this).data('slide');
        const layout = $('.apartment-image.active').data('layout');
        window.layout1 = layout;
        let displayBoxIndex = targetSlide -1 ;//2+1
        var Navigate = function(diff) {
            displayBoxIndex += diff;
            var oBoxCollection = $(".apartment-images-modal .navigation-image.visible");
            if (displayBoxIndex >= oBoxCollection.length){//3
                displayBoxIndex = 0;
            }
            if (displayBoxIndex < 0) {
                displayBoxIndex = oBoxCollection.length - 1;
            }
            var cssClass = "current-slide";
            oBoxCollection.removeClass(cssClass).eq(displayBoxIndex).addClass(cssClass);
            if (displayBoxIndex === 0) {
                $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${displayBoxIndex+1}"][data-layout="${layout1}"]`).addClass('active');
            } else {
                $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${displayBoxIndex+1}"]`).addClass('active')
            }

        }

        $("body").keydown(function(e) {
            if (e.keyCode == 37) {//left
                Navigate(-1,targetSlide -1 );
            }
            if(e.keyCode == 39 ) {//right
                Navigate(1,targetSlide -1 );
            }
        })
    })
    $('.apartment-images-modal .navigation-image').on('click', function() {
        const targetSlide = $(this).data('slide');
        const layout = $(this).data('layout');

        $('.apartment-images-modal .navigation-image').removeClass('current-slide').filter(`[data-slide="${targetSlide}"]`).addClass('current-slide');
        window.location.hash = 'apartment-images-'+targetSlide+'-layout-'+layout;
        $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${targetSlide}"][data-layout="${layout}"]`).addClass('active');
    });
    $(window).on('hashchange', function() {
        if (window.location.hash.includes("apartment-images-")) {
            const a = window.location.hash.split('layout-')[1];
            const targetSlide = window.location.hash.split('apartment-images-')[1];
            let sub = targetSlide.substring(0,1)
            $('.apartment-images-modal .navigation-image').removeClass('current-slide').filter(`[data-slide="${sub}"]`).addClass('current-slide');
            $('.apartment-images-modal .modal-image').removeClass('active').filter(`[data-slide="${sub}"][data-layout="${a}"]`).addClass('active');
        }else {
            if (window.location.href.indexOf("layout") > -1) {
                $('.apartment-images-modal').removeClass('active');
                $('body').removeClass('overflow-hidden');
                document.URL.split('&layout')[0];
                history.go(-1)
            }else {
                $('.apartment-images-modal').removeClass('active');
                $('body').removeClass('overflow-hidden');
                document.URL.split('&layout')[0];
            }
        }
    })

    $('.apartment-images-modal .close-button').on('click', function() {
        $('.apartment-images-modal').removeClass('active');
        $('body').removeClass('overflow-hidden');
        let url = document.URL.split('#')[0];
        window.history.pushState('', '/', url);
    })

    if (window.location.hash.includes("apartment-images")) {
        $('.apartment-images-modal').addClass('active');
        $('body').addClass('overflow-hidden');
    }

    $( document ).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) { // ESC
            $('.apartment-images-modal').removeClass('active')
            $('body').removeClass('overflow-hidden');
            let url = document.URL.split('#')[0];
            window.history.pushState('', '/', url);
        }
    });

    //apartment floor images modal start

    $('.page-template-template-apartment .other-apartments .image-block').on('click', function() {
        const targetSlide = $(this).data('floor');
        $('.apartment-floor-images-modal .modal-image').removeClass('active').filter(`[data-slide="${targetSlide}"]`).addClass('active');
        $('.apartment-floor-images-modal .navigation-image').removeClass('current-slide').filter(`[data-slide="${targetSlide}"]`).addClass('current-slide');
        $('.apartment-floor-images-modal').addClass('active');
        $('body').addClass('overflow-hidden');
        window.location.hash = `apartment-floor-images`;
    });

    $('.apartment-floor-images-modal .navigation-image').on('click', function() {
        const targetSlide = $(this).data('slide');
        $('.apartment-floor-images-modal .navigation-image').removeClass('current-slide').filter(`[data-slide="${targetSlide}"]`).addClass('current-slide');
        $('.apartment-floor-images-modal .modal-image').removeClass('active').filter(`[data-slide="${targetSlide}"]`).addClass('active');
    });

    $('.apartment-floor-images-modal .close-button').on('click', function() {
        $('.apartment-floor-images-modal').removeClass('active');
        $('body').removeClass('overflow-hidden');
        var url = document.URL.split('#')[0];
        window.history.pushState('', '/', url);
    })

    if (window.location.hash.includes("apartment-floor-images")) {
        $('.apartment-floor-images-modal').addClass('active');
        $('body').addClass('overflow-hidden');
    }

    $('.single-floor-item').on('click', function() {
        const layoutName = $(this).data('floor');
        $('.single-floor-item').removeClass('active');
        $(this).addClass('active');
        $('.page-template-template-apartment .other-apartments .image-block').removeClass('current').filter(`[data-floor="${layoutName}"]`).addClass('current');
        $('.apartment-floor-images-modal .modal-image[data-slide="1"]').removeClass('active').filter(`[data-slide="${layoutName}"]`).addClass('active');
        $('.apartment-floor-images-modal .navigation-image[data-slide="1"]').removeClass('visible').filter(`[data-slide="${layoutName}"]`).addClass('visible');
    });
    const mobileApartmentsList = $('.similar-apartments-table-mobile .apartment');
    $('.buildings-selection input[name="building-name"]').each(function(index, el) {
        $(el)[0].checked = false
    });
    $('.buildings-selection input[name="building-name"]').on('change', function() {
        const filters = $('.buildings-selection').serializeArray();
        const buildingIds = [];
        $(filters).each(function(index, el) {
            buildingIds.push(Number(el.value));
        })
        mobileApartmentsList.removeClass('building-hidden');
        if (buildingIds.length) {
            const filteredApartments = mobileApartmentsList.filter(function () {
                return !buildingIds.includes($(this).data('building'));
            });
            filteredApartments.addClass('building-hidden');
        }
    })

    $('.page-template-template-apartment .toggle-list li').on('click', function () {
        if ($(this).hasClass('active')) return;

        const tab = $(this).data('tab');
        $(this).addClass('active').siblings().removeClass('active');

        $('.info-signs-tab-content .tab').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
    })
    $('.page-template-template-apartment .apartment-images .tooltip, [data-modal-legend]').on('click', function () {
        $('.info-signs-modal').addClass('active');
        $('body').addClass('fixed');
    })
    $('.page-template-template-apartment .info-signs-modal .close-button').on('click', function () {
        $('.info-signs-modal').removeClass('active');
        $('body').removeClass('fixed');
    })
    $(document).on('keyup',function(evt) {
        if (evt.keyCode === 27) {
            $('.info-signs-modal').removeClass('active');
            $('body').removeClass('fixed');
        }
    });
    if ($('.page-template-template-apartment').length) {
        $('.toggle-list-mobile .header').on('click', function () {
            const parent = $(this).closest('.toggle-list-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        });

        $('.toggle-list-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const parent = $(this).closest('.toggle-list-mobile');
            const tabName = $(this).text();
            const nav = $(parent).find('ul');

            $(this).addClass('active').siblings().removeClass('active');
            parent.toggleClass('active');
            nav.slideToggle();
            parent.find('.header p').text(tabName);
            // if ($(this).hasClass('active')) return;

            const tab = $(this).data('tab');
            $(this).addClass('active').siblings().removeClass('active');

            $('.info-signs-tab-content .tab').removeClass('active').filter(`[data-tab="${tab}"]`).addClass('active');
        });
    }

    // Booking interest form, when apartment is booked
    $('.booking-interest-form .button').on('click', function(e) {
        const formWrapper = $(this).closest('.form-wrapper');
        const email = formWrapper.find('#email')[0].value;
        const newsletter = formWrapper.find('#liven-newsletter')[0].checked;
        const apartment_id = formWrapper.data('apartment-id');
        const language = formWrapper.data('language');

        const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

        formWrapper.find('.input-wrap').removeClass('error');
        formWrapper.find('.response-error').removeClass('active');

        if (!email || !validateEmail(email)) {
            formWrapper.find('.input-wrap').addClass('error');
        } else {
            formWrapper.addClass('loading');

            $.post(liven.ajax_url, {
                'action': 'record_booking_interest',
                'email': email,
                'apartment_id': apartment_id,
                'language': language,
                'newsletter': newsletter
            }, function (response) {
                if (response.success) {
                    formWrapper.find('.booking-interest-form').remove();
                    formWrapper.find('.response-success').addClass('active');
                } else {
                    formWrapper.find('.response-error').addClass('active');
                }

                setTimeout(function () {
                    formWrapper.removeClass('loading');
                }, 1000)
            });
        }
    })

    // Popup send quote to email
    $('.trigger-price-offer-popup').on('click', function() {
       $('.popup-send-quote-email').addClass('active');

       // update hidden input values
        // #input_6  - layout_id
        // #input_7  - parking
        // #input_8  - storage

        $('.popup-send-quote-email form input[name="input_6"]').val($('input[name="layout"]:checked').closest('li').index() >= 0 ? $('input[name="layout"]:checked').closest('li').index() : 0);
        $('.popup-send-quote-email form input[name="input_7"]').val($('.parking-choices select')[0].selectedIndex - 1);
        $('.popup-send-quote-email form input[name="input_8"]').val($('.storage-choices select')[0].selectedIndex - 1);
    });

    $('.popup-send-quote-email .close-btn').on('click', function() {
        $(this).closest('.popup-send-quote-email').removeClass('active');
    });

    /**
     * Swiper (Horizontal)
     */
    var swiperLayoutSlider = new Swiper('.js-layout-thumbs-slider', {
        navigation: {
            nextEl: '.c-swiper-button-item__next',
            prevEl: '.c-swiper-button-item__prev',
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            991: {
                spaceBetween: 32
            }
        },
        pagination: {
            el: '.c-swiper-progress',
            type: 'progressbar',
        },
        preventClicks: false
    });

    var zoomThumbnailsVertical = new Swiper('.js-zoom-thumbnails-vertical', {
        navigation: {
            nextEl: '.c-swiper-button-item__next',
            prevEl: '.c-swiper-button-item__prev',
        },
        direction: 'vertical',
        //slidesPerView: 'auto',
        slidesPerView: 6,
        slidesPerGroup: 5,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        preventClicks: false,
        breakpoints: {
            1440: {
                slidesPerView: 5,
            },
        },
        allowTouchMove: false
    });

    /**
     * Init Panzoom
     */
    $('.c-image-zoom-scene').each(function( index, element ) {
        var currentSceneID = $(this).attr('id');
        ppLayoutPanzoom[currentSceneID] = Panzoom( document.querySelector('#'+currentSceneID), {
            maxScale: 6,
            minScale: 0.75,
            contain: 'outside'
        });
    });

    /**
     * Load image to Zoom photo component
     */
    $(document).on('click', '[data-load-zoom-image]', function(e) {
        e.preventDefault();

        var newZoomImage = $(this).data('load-zoom-image');
        var imageStyle = $(this).data('zoom-image-style');
        var clickedIndex = $('[data-load-zoom-image]').index(this);

        // Handle active UI classnames
        $(this).closest('.swiper-wrapper').find('.c-grid-swiper-card').removeClass('is-active');
        $(this).closest('.swiper-wrapper').find('.c-zoom-thumb-item').removeClass('is-active');
        $(this).addClass('is-active');

        // Add style classname (contain or cover)
        if( imageStyle == 'contain' ) {
            $('.c-tab-panel.is-active').find('.c-image-zoom-scene > img').removeClass('cover');
        }
        if( imageStyle == 'cover' ) {
            $('.c-tab-panel.is-active').find('.c-image-zoom-scene > img').removeClass('contain').addClass('cover');
        }

        // Replace image
        $('.c-tab-panel.is-active').find('.c-image-zoom-scene > img').attr('src', newZoomImage);

    });

    $(document).on('click', '.a-zoom-button--in', function(e) {
        e.preventDefault();
        var currentSceneID = $('.c-tab-panel.is-active').find('.c-image-zoom-scene').attr('id');
        ppLayoutPanzoom[currentSceneID].zoomIn();

    });

    $(document).on('click', '.a-zoom-button--out', function(e) {
        e.preventDefault();
        var currentSceneID = $('.c-tab-panel.is-active').find('.c-image-zoom-scene').attr('id');
        ppLayoutPanzoom[currentSceneID].zoomOut();

    });

    $(document).on('click', '.a-zoom-button--reset', function(e) {
        e.preventDefault();
        var currentSceneID = $('.c-tab-panel.is-active').find('.c-image-zoom-scene').attr('id');
        ppLayoutPanzoom[currentSceneID].reset();

    });

    $('.c-image-zoom-body').bind('mousewheel DOMMouseScroll', function(event) {
        // This binds to shift + wheel
        if ( !event.shiftKey ) {
            return;
        }
        var currentSceneID = $('.c-tab-panel.is-active').find('.c-image-zoom-scene').attr('id');
        ppLayoutPanzoom[currentSceneID].zoomWithWheel(event);
    });

    $(document).keydown(function (e) {
        // left arrow
        if ((e.keyCode || e.which) == 37) {
            $('.c-tab-panel.is-active').find('.c-zoom-thumb-item.is-active').parent().prev('.swiper-slide').find('.c-zoom-thumb-item').trigger('click');
        }
        // right arrow
        if ((e.keyCode || e.which) == 39) {
            $('.c-tab-panel.is-active').find('.c-zoom-thumb-item.is-active').parent().next('.swiper-slide').find('.c-zoom-thumb-item').trigger('click');
        }
    });

    /**
     * Switch to different sections
     */

    // Function to handle URL changes
    function handleUrlChange() {
        // Get the current URL
        const urlParams = new URLSearchParams(window.location.search);
        const switchSection = urlParams.get('switch-section');
        if (switchSection) {
            // Find the element with the data-switch-section attribute matching the parameter
            const targetElement = document.querySelector(`[data-switch-section="${switchSection}"]`);
            if (targetElement) {
                // Here you can manipulate the target element as needed
                // For example, adding a class, scrolling to it, etc.
                targetElement.classList.add('active');  // Example: add a class
                targetElement.click();
                //targetElement.scrollIntoView({ behavior: 'smooth' });  // Example: scroll to element
            }
        }
        if ( switchSection == null ) {
            $('[data-switch-section="plan"]').trigger('click');
        }
    }

    /*
    if ( $( '[data-switch-section]' ).length ) {

        // Listen for the initial page load
        //window.addEventListener('load', handleUrlChange);

        // Listen for popstate events (back/forward navigation)
        window.addEventListener('popstate', handleUrlChange);
    }
    */

    $(document).on('click', '[data-switch-section]', function(e) {
        e.preventDefault();

        var switchTarget = $(this).data('switch-section');
        var goToUrl = $(this).data('url-redirect');
        var switchParamType = '';
        /*
        switch (switchTarget) {
            case 'table':
                $('#tab-plan').hide();
                $('#tab-table').show();
                $('#mobile-filter-triggers').removeClass('is-hidden');
                switchParamType = 'table';
                break;
            case 'plan':
                $('#tab-plan').show();
                $('#tab-table').hide();
                $('#mobile-filter-triggers').addClass('is-hidden');
                $('.checkbox-multiple.building-name input[type="checkbox"]').prop('checked', false);
                switchParamType = 'plan';

                break;
            default:
                switchParamType = 'plan';
                console.log('No section is defined where to switch the UI.');
        }
        */


        //window.history.pushState(null, null, "?switch-section="+switchParamType );
        ////handleUrlChange();

        window.location.href = goToUrl;

    });

    if( $('.c-toggle-list').length > 0 && $('#tab-plan').length > 0 && $('#tab-plan').hasClass('is-shown')) {
        $('#mobile-filter-triggers').addClass('is-hidden');
    }

    /**
     * Filter house by marker
     */
    $(document).on('click', '[data-filter-house]', function(e) {
        e.preventDefault();

        var filterTarget = $(this).data('filter-house');

        // Switch layout
        $('#tab-plan').hide();
        $('#tab-table').show();

        // Trigger correct house filter
        var inputToClick = $('input[name="building-name-desktop"][value="' + filterTarget + '"]');
        if (inputToClick.length > 0) {
            inputToClick.closest('label').click();
        } else {
            console.log("Input with value " + filterTarget + " not found.");
        }

    });

    //js-map-plan-filter-button

    /**
     * Scroll To
     */
    $(document).on('click', '[data-scroll-to]', function(e) {
        e.preventDefault();

        var scrollTarget = $(this).data('scroll-to');

        $('html, body').animate({
            scrollTop: $(scrollTarget).offset().top - 32
        }, 800);

    });

    /**
     * SINGLE HOME VIEW
     */
    if ( $('.single-home').length ) {

        /**
         * Change view if parameter view is in URL
         */
        var urlParams = new URLSearchParams(window.location.search);
        if ( urlParams.has('view') ) {
            //console.log('The view parameter is in the URL: ' + urlParams.get('view'));
            $('.apartments-block .toggle-list').find('[data-tab="'+urlParams.get('view')+'"]').trigger('click');
        }

        /**
         * Set view preference as URL param
         */
        $('.apartments-block .toggle-list li').on('click', function (e) {
            var viewPreference = $(this).data('tab');

            var url = new URL(window.location.href);
                url.searchParams.set('view', viewPreference);
                window.history.pushState({path: url.href}, '', url.href);

        });
    }

})(jQuery);
